import n, { css as t } from "styled-components";
import { UL as d, LI as r } from "./atoms-v2777.js";
import { Picture as p } from "./atoms-v233.js";
const x = n.ul`
  ${d}

  color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.primary")};
  display: flex;
  flex-direction: column;
  gap: 24px;
`, g = n.li`
  ${r}

  display: flex;
  flex-direction: column;
  gap: ${({ $variant: o }) => o === "small" ? "8px" : "16px"};
`, f = n.div`
  ${({ $variant: o, theme: i }) => {
  var s, l;
  return o === "small" ? t`
        ${(s = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : s.toJS()}
      ` : t`
      ${(l = i == null ? void 0 : i.get("tokens.heading.02")) == null ? void 0 : l.toJS()}
    `;
}}
`, $ = n.ul`
  ${d}

  display: flex;
  flex-direction: column;
  gap: ${({ $variant: o }) => o === "small" ? "6px" : "12px"};
`, u = n.li`
  ${r}

  align-items: flex-start;
  display: flex;
`, y = n(p)`
  border-radius: ${({ theme: o }) => `${o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px`};
  flex-shrink: 0;
`, v = n.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  padding-bottom: ${({ $variant: o }) => o === "small" ? "14px" : "16px"};
  padding-inline: ${({ $variant: o }) => o === "small" ? "20px" : "24px"};
  padding-top: ${({ $variant: o }) => o === "small" ? "12px" : "16px"};
  width: 100%;
`, k = n.div`
  display: flex;
  flex-direction: column;

  ${({ $isSkeleton: o = !1 }) => o && t`
      gap: 14px;
    `}
`, b = n.div`
  ${({ $variant: o, theme: i }) => {
  var s, l;
  return o === "small" ? t`
        ${(s = i == null ? void 0 : i.get("tokens.body.productive")) == null ? void 0 : s.toJS()}
      ` : t`
      ${(l = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : l.toJS()}
    `;
}}
`, A = n.div`
  ${({ $variant: o, theme: i }) => {
  var s, l;
  return o === "small" ? t`
        ${(s = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : s.toJS()}
      ` : t`
      ${(l = i == null ? void 0 : i.get("tokens.helper.expressive")) == null ? void 0 : l.toJS()}
    `;
}}

  color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.secondary")};
`, O = n.div`
  -webkit-box-orient: vertical;
  color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.secondary")};
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}
  display: -webkit-box;
  -webkit-line-clamp: 2;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ $isSkeleton: o = !1 }) => o && t`
      display: flex;
      flex-direction: column;
      gap: 11px;
      margin-bottom: 11px;
    `}
`, S = n.div`
  height: ${({ $variant: o }) => o === "small" ? 120 : 180}px;
  width: ${({ $variant: o }) => o === "small" ? 120 : 180}px;
`, w = n.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`, I = n.div`
  display: flex;
  gap: 16px;
`, J = n.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;
export {
  x as AddOns,
  g as AddOnsCategory,
  $ as AddOnsCategoryList,
  f as AddOnsCategoryName,
  u as AddOnsItem,
  v as AddOnsItemContent,
  O as AddOnsItemDescription,
  k as AddOnsItemHeader,
  y as AddOnsItemPicture,
  S as AddOnsItemPictureSkeletonWrapper,
  A as AddOnsItemSubtitle,
  b as AddOnsItemTitle,
  w as HeaderWrapper,
  J as SelectedAddonsContent,
  I as SelectedAddonsContentWrapper
};
